import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { routesForAuthenticatedOnly, routesForNotAuthenticatedOnly } from "../../../app/routes";
import useRoutePathMatch from "@jumbo/hooks/useRoutePathMatch";
import { AuthContext } from "@jumbo/components/JumboAuthProvider/JumboAuthContext";
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginAuth, loginUser, setAllAuthorizedInsts, setAllAuthorizedUnits, setAllReadAuthorizedInsts, setAllReadAuthorizedUnits, setUserAndToken } from 'stores/auth';
import { CircularProgress, Dialog } from '@mui/material';
import LoginDialog from 'app/components/Dialog/LoginDialog';
import { getUnitAPI } from 'stores/unit';
import { getSubjectAPI } from 'stores/subject';
import { NotificationManager } from 'react-notifications';
import { getUserAPI } from 'stores/user';
import { getAuthorizedUnitsFromUserIdApi, getReadAuthorizedUnitsFromUserIdApi } from 'api/user';
import { getAgendaTemplatesAPI } from 'stores/general';
import { hasKurulRole, swal_role_denied } from 'app/utils/appHelpers';
const localToken = localStorage.getItem("token");


const JumboAuthProvider = ({ children, ...restProps }) => {
    const [logout, setLogout] = React.useState(false);
    const navigate = useNavigate();
    const isAuthenticatedRouteOnly = useRoutePathMatch(routesForAuthenticatedOnly);
    const isNotAuthenticatedRouteOnly = useRoutePathMatch(routesForNotAuthenticatedOnly);

    const [loginDialogStatus, setLoginDialogStatus] = useState(false);
    const { authUser, isLoading, isError, isSuccess, message } = useSelector(state => state.auth)


    const search = useLocation().search;
    const dispatch = useDispatch();

    useEffect(() => {

        try {
            const params = new URLSearchParams(search);
            const localToken = localStorage.getItem("token");
            const localUser = localStorage.getItem("user");

            if (localToken === null || localUser === null) {
                const token = params.get("t") !== null ? params.get("t").split("?")[0] : "";
                if (token !== null) {
                    if (token !== "") {
                        localStorage.setItem("token", token);
                        dispatch(loginUser({ token }));
                    }
                    else {
                        // navigate("/login");
                        setLoginDialogStatus(true)
                    }

                }
            } else {
                console.log('clo load user ')
            }

            if (localStorage.getItem('user') === "undefined" || localStorage.getItem('user') === undefined) {
                localStorage.removeItem("user");
                localStorage.removeItem("token");
                window.location.replace(process.env.REACT_APP_MAIN_PAGE_URL);
            } else if (localStorage.getItem('user')) {
                const storedUser = JSON.parse(localStorage.getItem('user'));
                if (!hasKurulRole(storedUser?.userRoles)) {
                    localStorage.removeItem("user");
                    localStorage.removeItem("token");
                    swal_role_denied();
                } else {
                    dispatch(loginAuth(storedUser));
                }
            }
        } catch (error) {
            localStorage.removeItem("user");
            localStorage.removeItem("token");
            window.location.replace(process.env.REACT_APP_MAIN_PAGE_URL);
        }


    }, [])

    useEffect(() => {
        const fetchAuthorizedUnits = async () => {
            const localToken = localStorage.getItem("token");
            const storedUserRaw = localStorage.getItem("user");
            let storedUser = null;
            try {
                storedUser = storedUserRaw ? JSON.parse(storedUserRaw) : null;
            } catch (error) {
                storedUser = null;
            }
            if (localToken !== null && hasKurulRole(storedUser?.userRoles)) {

                dispatch(getUserAPI())
                dispatch(getUnitAPI())
                dispatch(getSubjectAPI())
                dispatch(getAgendaTemplatesAPI())
            } else {
                console.log('clo load user ')
            }
        }
        fetchAuthorizedUnits();

    }, [authUser])




    const allAuthorizedUnits = useSelector(state => state.auth.allAuthorizedUnits);
    const allReadAuthorizedUnits = useSelector(state => state.auth.allReadAuthorizedUnits);



    // Kullanıcının yetkili olduğu unitleri çekiyoruz.
    useEffect(() => {
        const fetchAuthorizedUnits = async () => {

            if (authUser && hasKurulRole(authUser.userRoles) && allAuthorizedUnits.length === 0) {
                const res = await getAuthorizedUnitsFromUserIdApi(authUser.id);
                const data = res?.data;
                if (!Array.isArray(data)) return;

                dispatch(setAllAuthorizedUnits(data));
                const uniqueInsts = [...new Set(data.map(item => item.inst))];
                dispatch(setAllAuthorizedInsts(uniqueInsts));

            }
        };


        fetchAuthorizedUnits();

        const fetchReadAuthorizedUnits = async () => {
            if (authUser && hasKurulRole(authUser.userRoles) && allReadAuthorizedUnits.length === 0) {
                const resRead = await getReadAuthorizedUnitsFromUserIdApi(authUser.id);
                const dataRead = resRead?.data;
                if (!Array.isArray(dataRead)) return;
                dispatch(setAllReadAuthorizedUnits(dataRead));
                const uniqueInstsRead = [...new Set(dataRead.map(item => item.inst))];
                dispatch(setAllReadAuthorizedInsts(uniqueInstsRead));


            }
        };
        fetchReadAuthorizedUnits();

    }, [authUser, allAuthorizedUnits.length, allReadAuthorizedUnits.length, dispatch]);


    const contextValue = React.useMemo(() => {
        return { ...authUser }
    }, [authUser]);


    useEffect(() => {
        if (isError && message === "Rolünüz bulunmamaktadır.") {
            swal_role_denied();
            return;
        }
        if (isError) {
            NotificationManager.error('Oturmun süresi doldu yeniden giriş yapmanız gerekiyor. ' + message)

        }

    }, [authUser, isLoading, isError, isSuccess, message, dispatch])

    if (isLoading) {
        return <CircularProgress />
    }

    const afterLogin = (user, token) => {
        // console.log('afterLogin neden çalıştı ')

        dispatch(setUserAndToken({ user, token }));

    }

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
            <LoginDialog open={loginDialogStatus} onClose={() => setLoginDialogStatus(false)} afterLogin={afterLogin} />
        </AuthContext.Provider>
    );
};

export default JumboAuthProvider;

